export const FETCH_ACTIVITY_LOGS_REQUEST = 'FETCH_ACTIVITY_LOGS_REQUEST';
export const FETCH_ACTIVITY_LOGS_SUCCESS = 'FETCH_ACTIVITY_LOGS_SUCCESS';
export const FETCH_ACTIVITY_LOGS_FAILURE = 'FETCH_ACTIVITY_LOGS_FAILURE'; 